/* skip-link.tsx generated by @compiled/babel-plugin v0.29.1 */
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */
import "./skip-link.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Anchor } from '@atlaskit/primitives';
var styles = {
  skipLinkListItem: "_1pfhze3t"
};
var assignIndex = function assignIndex(num, arr) {
  if (!arr.includes(num)) {
    return num;
  }
  return assignIndex(num + 1, arr);
};
var handleBlur = function handleBlur(event) {
  // @ts-ignore
  event.target.removeAttribute('tabindex');
  // @ts-ignore
  event.target.removeEventListener('blur', handleBlur);
};
var focusTargetRef = function focusTargetRef(href) {
  return function (event) {
    event.preventDefault();
    var targetRef = document.querySelector(href);

    // @ts-ignore
    var key = event.which || event.keycode;
    // if it is a keypress and the key is not
    // space or enter, just ignore it.
    if (key && key !== 13 && key !== 32) {
      return;
    }
    if (targetRef) {
      targetRef.setAttribute('tabindex', '-1');
      // @ts-ignore
      targetRef.addEventListener('blur', handleBlur);
      // @ts-ignore
      targetRef.focus();
      document.activeElement && document.activeElement.scrollIntoView({
        behavior: 'smooth'
      });
      window.scrollTo(0, 0);
    }
    return false;
  };
};

/**
 * A link that moves current tab position to a different element
 */
export var SkipLink = function SkipLink(_ref) {
  var href = _ref.href,
    children = _ref.children,
    isFocusable = _ref.isFocusable;
  return /*#__PURE__*/React.createElement("li", {
    className: ax([styles.skipLinkListItem])
  }, /*#__PURE__*/React.createElement(Anchor, {
    tabIndex: isFocusable ? 0 : -1,
    href: href,
    onClick: focusTargetRef(href)
  }, children));
};